export const navItemsByHotel: { [hotelName: string]: string[] } = {
  bluepin: ["Room ready", "Pre-arrival", "Pre-auth", "Confirmation"],
  mini: ["Room ready", "Pre-arrival", "Pre-auth", "Confirmation"],
  parklane: ["Room ready", "Pre-arrival"],
  goldCoast: ["Pre-arrival"],
  melbourne: ["Pre-arrival"],
  dorsettWanchai: ["Pre-arrival"],
  london: ["Pre-arrival"],
  icon: ["Room ready", "Pre-arrival"],
  southPacific: ["Pre-arrival"],
  daobyDorsett: ["Pre-arrival"],
  dorsettSingapore: ["Pre-arrival", "Room ready"],
  holidayInnExpressSingaporeKatong: ["Pre-arrival", "Room ready"],
  holidayInn: ["Room ready", "Pre-arrival"],
  royalGarden: ["Pre-arrival"],
  royalPlaza: ["Pre-arrival", "Room ready", "Remote Control"],
  dorsettMongkok: ["Pre-arrival"],
  dorsettKaiTak: ["Pre-arrival"],
  dorsettCanary: ["Pre-arrival"],
  hopewell: ["Pre-arrival"],
  regal: ["Room ready"],
  royalPacific: ["Room ready"],
  amara: ["Pre-arrival"],
  east: ["Pre-arrival", "Room ready"],
  garner: ["Pre-arrival", "Room ready"],
  cp: ["Pre-arrival", "Room ready", "Payment"],
  GrandLisboaPalace: ["Room ready"],
};
